import React from 'react';
import { AlertIcon, TOOLTIP_POSITION, TooltipV2 as Tooltip } from 'taboola-ultimate-ui';
import styles from './parameter.module.scss';

export const Parameter = ({ name, value, validationError, isUrlEvent }) => {
    const formattedValue = isUrlEvent ? ` "${value}"` : ` ${value}`;

    return (
        <div className={styles['value']}>
            <div className={styles['text-container']}>
                {name}: <strong>{formattedValue}</strong>
            </div>
            {validationError && (
                <div className={styles['icon-container']}>
                    <AlertIcon className={styles['alert-icon']} />
                    <Tooltip arrow placement={TOOLTIP_POSITION.RIGHT}>
                        {validationError}
                    </Tooltip>
                </div>
            )}
        </div>
    );
};
